import { Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'grid-textbox-or-text-renderer',
    templateUrl: './grid-textbox-or-text-renderer.component.html',
    standalone: false
})

export class GridTextBoxOrTextRendererComponent implements ICellRendererAngularComp {
    placeHolder = "";
    maxLength: number;
    value: any;
    params: any;
    isRequired: boolean = false;
    showValidator: boolean = false;
    isShowText: boolean = false;
    disabled: boolean = false;


    initilize(params: ICellRendererParams) {

        if (params && params.data && params.data.isShowText) {
            this.isShowText = params.data.isShowText;
        }

        if (params && params.data && params.data.disabled) {
            this.disabled = params.data.disabled;
        }

        if (params.colDef.headerComponentParams) {
            if (params.colDef.headerComponentParams.maxLength) {
                this.maxLength = params.colDef.headerComponentParams.maxLength;
            }

            if (params.colDef.headerComponentParams.placeHolder) {
                this.placeHolder = params.colDef.headerComponentParams.placeHolder;
            }

            if (params.colDef.headerComponentParams.isRequired) {
                this.isRequired = params.colDef.headerComponentParams.isRequired;
            }
        }

        this.value = params.getValue();
    }

    agInit(params: any): void {
        this.params = params;
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    onInput($event) {
        if (this.params.onInput instanceof Function) {
            this.showValidator = false;

            let params = { event: $event, rowData: this.params.node.data }
            this.params.onInput(params);

            if (!this.NoWhitespaceValidator($event.target.value) && this.isRequired) {
                this.showValidator = true;
                return;
            }
        }
    }


    NoWhitespaceValidator(value: string): boolean {
        if (value == null) {
            value = "";
        }

        const isWhitespace = (value || "").trim().length === 0;

        return !isWhitespace;
    }

}
